import { isValidPhone, DEFAULT_PHONE_MESSAGE } from './phone';
import type { TValidatorValue } from './models';
import { validateNotEmpty } from './not-empty';
import { composeValidators, validate } from './utils';

/**
 * Список запрещенных в Альфе телефонов
 */
const alfaBlockedPhones = [
    '70000000000',
    '71111111111',
    '72222222222',
    '73333333333',
    '74444444444',
    '75555555555',
    '76666666666',
    '77777777777',
    '78888888888',
    '79999999999',
    '70987654321',
    '71234567890',
    '70123456789',
    '79876543210',
];

export const isValidAlfaPhone = (value?: string) => isValidPhone(value, alfaBlockedPhones);

const validateAlfaPhoneValue = (customMessage?: string) => (value: TValidatorValue) =>
    validate(isValidAlfaPhone(value), DEFAULT_PHONE_MESSAGE, customMessage);

export const validateAlfaPhone = (message?: string) =>
    composeValidators(validateAlfaPhoneValue(message), validateNotEmpty());
